/* eslint-disable import/prefer-default-export */
import request from 'utils/request';


export async function setState(params) {
  return request({
    url: '/state/set-state',
    method: 'post',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/state.js